import React from 'react';

interface SettingRowProps {
    label: React.ReactNode;
    content: React.ReactNode;
    alignTop?: boolean;
}

const SettingRow: React.FC<SettingRowProps> = ({ label, content, alignTop = false }) => (
    <div className={`flex ${alignTop ? 'items-start' : 'items-center'} justify-between`}>
        <span className={`text-sm font-medium ${alignTop ? 'mt-2 max-w-24' : ''}`}>{label}</span>
        {content}
    </div>
);

export default SettingRow;
